import { render } from "./my-pages.vue?vue&type=template&id=6814340a"
import script from "./my-pages.vue?vue&type=script&lang=js"
export * from "./my-pages.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__